import type { FriendsResponse } from "../model/FriendsBoard";

// Друзей загружают в фоне. Перезапрашиваем раз в 5 секунд, пока идёт первая загрузка
// (`pending`, не дольше 2 минут — как ожидание сводки) или пока после «Проверить снова»
// не пришёл снимок новее нажатия. Дальше экран обновит событие `friends.updated`.
export const FRIENDS_POLL_INTERVAL_MS = 5_000;
export const FRIENDS_POLL_MAX_FETCHES = 24;
export const FRIENDS_REFRESH_WAIT_MS = 120_000;

export const isFriendsWaiting = (
  data: FriendsResponse | undefined,
  fetchCount: number,
  // Когда нажали «Проверить снова», мс; не нажимали — `null`.
  refreshedAt: number | null,
  now: number = Date.now(),
): boolean => {
  if (data?.status === "pending") {
    return fetchCount < FRIENDS_POLL_MAX_FETCHES;
  }
  if (refreshedAt === null || now - refreshedAt >= FRIENDS_REFRESH_WAIT_MS) {
    return false;
  }
  const syncedAt = data?.synced_at;
  return syncedAt === null || syncedAt === undefined || Date.parse(syncedAt) < refreshedAt;
};
